'use client';

import Image from '@/components/image';
import NextLink from '@/components/next-link';
import { handleLinkByType } from '@/utils/global';
import { event_select_promotion } from '@/utils/gtm';
import { setCookie } from 'cookies-next';
// import { banner_event } from '@/utils/gtm';

const HeroCard = ({ info, isMobile, locale, ref, sliderKey, position }) => {
  return (
    <>
      <NextLink
        onClick={() => {
          setCookie('promotion_id', info?.id);
          setCookie('promotion_name', info?.[`alt-${locale}`]);
          event_select_promotion({
            promotionImage: info?.[`img-${locale}`],
            key: sliderKey,
            position: position,
            id: info?.id,
            name: info?.[`alt-${locale}`],
            url: handleLinkByType(info?.url, info?.type),
          });
        }}
        ref={ref}
        href={handleLinkByType(info?.url, info?.type)}
      >
        <Image
          src={
            isMobile ? info?.[`mobile-img-${locale}`] : info?.[`img-${locale}`]
          }
          className='h-auto w-full object-contain'
          alt={info?.[`alt-${locale}`] || 'Banner Img!'}
        />
      </NextLink>

      {/* <div className='absolute top-0 flex h-full w-full justify-center'>
        <Container className='flex flex-col justify-center gap-6 text-white max-sm:gap-3'>
          <p className='font-medium uppercase max-sm:text-[11px]'>
            {isMobile
              ? info?.[`subtitle-${locale}`]
              : info?.[`subtitle-${locale}`]}
          </p>
          <h1 className='text-[17px] font-semibold md:text-3xl lg:text-6xl'>
            {isMobile ? info?.[`title-${locale}`] : info?.[`title-${locale}`]}
          </h1>
          <p className='w-1/2 font-medium max-sm:line-clamp-1 max-sm:text-[11px] lg:w-[35%]'>
            {isMobile
              ? info?.[`description-${locale}`]
              : info?.[`description-${locale}`]}
          </p>
          <div className='flex items-center gap-[18px] max-sm:mt-2 max-sm:gap-2.5'>
            <NextLink
              href={info?.url || '#'}
              className='bg-primary rounded-lg px-10 py-2 font-medium max-sm:px-3 max-sm:py-1.5 max-sm:text-[11px]'
            >
              {t('common.shop_now')}
            </NextLink>
            <NextLink
              href={info?.contactUsUrl || '#'}
              className='rounded-lg border px-10 py-2 font-medium max-sm:px-3 max-sm:py-1.5 max-sm:text-[11px]'
            >
              {t('common.contact_us')}
            </NextLink>
          </div>
        </Container>
      </div> */}
    </>
  );
};

export default HeroCard;
